import {register} from '../../../assets/js/modules/eventMap';

const persistBranchStates = (prevTree, nextTree) => {
    const openTitles = [];
    prevTree.querySelectorAll('details[open] > summary').forEach((summary) => {
        openTitles.push(summary.getAttribute('title'));
    });

    nextTree.querySelectorAll('details > summary').forEach((summary) => {
        summary.parentElement.open = openTitles.includes(
            summary.getAttribute('title')
        );
    });
};

const persistState = (prevRoot, nextRoot) => {
    const prevTrees = prevRoot.querySelectorAll(
        '[data-kui-tree-view-state-persisted][id]'
    );
    const nextTrees = nextRoot.querySelectorAll(
        '[data-kui-tree-view-state-persisted][id]'
    );

    if (!prevTrees || !nextTrees) {
        return;
    }

    prevTrees.forEach((prevTree) => {
        const id = prevTree.id;
        if (!id) {
            return;
        }

        const nextTree = nextRoot.querySelector(
            `[data-kui-tree-view-state-persisted][id="${id}"]`
        );
        if (!nextTree) {
            return;
        }

        // Check if there's an active search
        const prevSearchInputEl = prevTree.querySelector(
            'input[type="search"]'
        );
        const nextSearchInputEl = nextTree.querySelector(
            'input[type="search"]'
        );

        if (prevSearchInputEl?.value) {
            // If there's an active search, apply it to the new tree AND
            // maintain branch states
            nextSearchInputEl.value = prevSearchInputEl.value;

            // First collect and restore branch states BEFORE applying search
            persistBranchStates(prevTree, nextTree);

            // Then apply search which will expand matching branches
            search(nextSearchInputEl);
        } else {
            // No search active, restore normal open/closed states
            persistBranchStates(prevTree, nextTree);
        }
    });
};

const resetTree = (itemsEl) => {
    itemsEl.forEach((item) => {
        item.hidden = false;
        const branchNode = item.querySelector('details');
        if (branchNode) {
            branchNode.open = false;
        }
    });
};

const search = (el) => {
    const rootEl = el.closest('[data-kui-tree-view]');
    if (!rootEl) {
        return;
    }

    const itemsListEl = rootEl.querySelector('[data-kui-tree-view-items]');
    if (!itemsListEl) {
        return;
    }

    const itemsEl = itemsListEl.querySelectorAll('li');
    if (!itemsEl.length) {
        return;
    }

    const noResultsEl = rootEl.querySelector(
        '[data-kui-tree-view-search-no-results]'
    );
    const searchTermMarkEl = noResultsEl?.querySelector('mark');
    const liveRegionEl = rootEl.querySelector('[aria-live]');

    // Early return if required elements missing
    if (!noResultsEl || !searchTermMarkEl || !liveRegionEl) {
        return;
    }

    // Handle empty search - reset tree view/no results/live region
    if (!el?.value) {
        resetTree(itemsEl);
        noResultsEl.hidden = true;
        liveRegionEl.textContent = '';
        return;
    }

    const searchTerm = el.value.toLowerCase();
    let matchCount = 0;
    const matchedBranchDescendants = new Set();

    // Update search term in no results message
    searchTermMarkEl.textContent = `${el.value}`;

    itemsEl.forEach((item) => {
        const itemText = item
            .querySelector('summary, a, button')
            ?.textContent.trim()
            .toLowerCase();
        const isMatch = itemText?.includes(searchTerm);
        const branchNode = item.querySelector('details');
        const isNested = !!item.parentElement.closest('li');

        if (isMatch) {
            matchCount++;
            item.hidden = false;

            // For nested items (branch or leaf), show parent hierarchy first
            if (isNested) {
                let parent = item.parentElement.closest('li');
                while (parent) {
                    parent.hidden = false;
                    const parentBranch = parent.querySelector('details');
                    if (parentBranch) {
                        parentBranch.open = true;
                    }
                    parent = parent.parentElement.closest('li');
                }
            }

            // If matching item is a branch, show its descendants
            if (branchNode) {
                branchNode.open = true;
                item.querySelectorAll('li').forEach((descendant) => {
                    descendant.hidden = false;
                    matchedBranchDescendants.add(descendant);
                });
            }
        } else if (!matchedBranchDescendants.has(item)) {
            item.hidden = searchTerm;
        }
    });

    // Toggle no results message
    if (noResultsEl) {
        noResultsEl.hidden = matchCount > 0 || !searchTerm;
    }

    // Update ARIA live region
    if (liveRegionEl && searchTerm) {
        liveRegionEl.textContent = `Found ${matchCount} ${
            matchCount === 1 ? 'item' : 'items'
        } matching “${searchTerm}”`;
    } else if (liveRegionEl) {
        liveRegionEl.textContent = '';
    }
};

const treeView = () => {
    register('treeView', {search});
};

export {treeView, persistState};
